module.exports = __webpack_public_path__ + "img/pdf.6455314b.svg";